import { defineNuxtPlugin, useRuntimeConfig } from '#app'

/* Плагин для прокидывания ID собранной статики в CDN */
export default defineNuxtPlugin({
  name: 'providePipelineId',
  setup() {
    const { PIPELINE_ID } = useRuntimeConfig().public

    return {
      provide: {
        pipelineId: PIPELINE_ID,
      },
    }
  },
})
